// src/pages/PagesUtilisateurs/DashboardUsers/data/dashboardModules.data.js

import {
  FaBell,
  FaBullseye,
  FaCalendarAlt,
  FaClipboardList,
  FaEnvelope,
  FaMoneyBillWave,
  FaStar,
} from "react-icons/fa";

export function buildDashboardModules({
  counts,
  isAdminOrTeacher = false,
}) {
  return [
    {
      id: "payments",
      title: "Règlements en attente",
      navTitle: "Règlements",
      description:
        "Consultez les règlements ou achats restant à effectuer.",
      icon: FaMoneyBillWave,
      count: counts?.payments?.total || 0,
      countLabel: "à régler",
      attention: (counts?.payments?.total || 0) > 0,
      tone: "amber",
    },

    {
      id: "notifications",
      title: "Notifications",
      navTitle: "Notifications",
      description:
        "Retrouvez les informations importantes liées à votre compte et à vos adhérents.",
      icon: FaBell,
      count: counts?.notifications?.unread || 0,
      countLabel: "non lue(s)",
      attention: (counts?.notifications?.unread || 0) > 0,
      tone: "blue",
    },

    {
      id: "messages",
      title: "Messages",
      navTitle: "Messages",
      description:
        "Consultez vos échanges avec les enseignants et les responsables du club.",
      icon: FaEnvelope,
      count: counts?.messages?.unread || 0,
      countLabel: "non lu(s)",
      attention: (counts?.messages?.unread || 0) > 0,
      tone: "blue",
    },

    {
      id: "objectifs",
      title: "Objectifs de saison",
      navTitle: "Objectifs",
      description:
        "Définissez et suivez les objectifs sportifs associés à vos adhérents.",
      icon: FaBullseye,
      count: counts?.objectifs?.total || 0,
      countLabel: "en cours",
      tone: "emerald",
    },

    {
      id: "events",
      title: "Évènements favoris",
      navTitle: "Évènements",
      description:
        "Retrouvez rapidement les évènements que vous avez enregistrés.",
      icon: FaCalendarAlt,
      count: counts?.events?.total || 0,
      countLabel: "favori(s)",
      tone: "emerald",
    },

    {
      id: "techniques",
      title: "Techniques favorites",
      navTitle: "Techniques",
      description:
        "Accédez à votre sélection personnelle de techniques de judo.",
      icon: FaStar,
      count: counts?.techniques?.total || 0,
      countLabel: "favorite(s)",
      tone: "emerald",
    },

    isAdminOrTeacher
      ? {
          id: "contact",
          title: "Formulaires de contact",
          navTitle: "Formulaires",
          description:
            "Consultez les messages transmis depuis les formulaires du site.",
          icon: FaClipboardList,
          count: counts?.contact?.unread || 0,
          countLabel: "non lu(s)",
          attention: (counts?.contact?.unread || 0) > 0,
          tone: "blue",
        }
      : null,
  ].filter(Boolean);
}